import { ModalComponentProps } from "../../types";
import InfoItem from "../common/InfoItem";
import CustomModal from "../ui/CustomModal";
import { targetTypes } from "./ManageAnnouncement";
import { ViewDetailsType } from "./ViewManageAnnouncement";

interface TargetIds {
  value?: string | number;
  label: string;
  photo?: string;
}

export default function ViewTargetData({
  data,
  handleClose,
  ...rest
}: ModalComponentProps<ViewDetailsType>) {
  const title =
    targetTypes?.find((item) => item?.value === data?.type)?.label + " List";

  const targetIds: TargetIds[] =
    data?.type === "employee"
      ? typeof data?.type_ids !== "string"
        ? data?.type_ids
            ?.map((item) => ({
              value: item?.business_member_id,
              label: item?.name,
              photo: item?.pro_pic,
            }))
            ?.filter((id) => id)
        : []
      : data?.type === "department"
      ? typeof data?.type_ids !== "string"
        ? data?.type_ids
            ?.map((item) => ({ value: item?.department_id, label: item?.name }))
            ?.filter((id) => id)
        : []
      : data?.type === "employee_type"
      ? typeof data?.type_ids !== "string"
        ? data?.type_ids
            ?.map((item) => ({ value: item?.type, label: item?.name }))
            ?.filter((id) => id)
        : []
      : [];

  return (
    <CustomModal
      title={title}
      {...rest}
      handleClose={handleClose}
      width={450}
      footer={null}
    >
      {targetIds?.map((el) => (
        <InfoItem
          key={el?.value}
          className="flex items-center gap-2"
          rootClassName="first:border-t"
        >
          {el?.photo ? (
            <img
              className="w-8 h-8 object-cover rounded-full"
              src={el?.photo}
              alt=""
            />
          ) : null}{" "}
          {el?.label}
        </InfoItem>
      ))}
    </CustomModal>
  );
}
